import { ColumnDef } from "@tanstack/react-table";
import { CampaignCode } from "@/lib/api/campaign-codes";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";

export const columns: ColumnDef<CampaignCode>[] = [
  {
    accessorKey: "code",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Code" />
    ),
    cell: ({ row }) => (
      <span className="font-mono font-medium">{row.original.code}</span>
    ),
  },
  {
    accessorKey: "slots",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Slots" />
    ),
    cell: ({ row }) => {
      const redeemed = row.original.redeemed_count ?? 0;
      const total = row.original.slots;
      return (
        <span>
          {redeemed} / {total}
        </span>
      );
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => (
      <span className="max-w-[200px] truncate">
        {row.original.description || "-"}
      </span>
    ),
  },
  {
    accessorKey: "enabled",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <Badge variant={row.original.enabled ? "default" : "secondary"}>
        {row.original.enabled ? "Active" : "Inactive"}
      </Badge>
    ),
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: ({ row }) => format(new Date(row.original.created_at), "MMM d, yyyy"),
  },
];
